import { Component, OnInit } from '@angular/core';
import {LoadsService} from "../../../services/loads/loads.service";
import { DocumentService } from "../../../services/document/document.service";
import {ActivatedRoute} from "@angular/router";
import {TruckLoadDetailModel} from "../../../models/loads/truck-load-detail.model";
import * as FileSaver from 'file-saver'
import {StatusHistoryModel} from "../../../models/status-history.model";


@Component({
  selector: 'app-truck-load-detail',
  templateUrl: './truck-load-detail.component.html',
  styleUrls: ['./truck-load-detail.component.scss']
})
export class TruckLoadDetailComponent implements OnInit {

  /*
  * Durum tarihçesi koşula bağlı success olacak.
  *
  * */
  truckLoadDetail: TruckLoadDetailModel = new TruckLoadDetailModel();
  lastStatus: StatusHistoryModel = null;
  isLoading: boolean = false;

  /*
  *  Durum kodları tmaxx durum tanımlarında belirtilmiştir.
  *  Varsayılan olarak rezervasyon durumu success olarak tanımlıdır.
  *  CT-01 Yükleme, CT-015 Araç Yolda, CT-05 Teslim Edildi, CT-06 Problemli Teslimat
  * */
  statusHistoryCodes = ['CT-01','CT-015','CT-05', 'CT-06']

  constructor(private loadService: LoadsService, private activatedRoute: ActivatedRoute, private documentService: DocumentService) {
    if(this.activatedRoute.snapshot.params.id) {
      this.loadService.getDomesticDistrubitonOrderPackDetail(this.activatedRoute.snapshot.params.id).subscribe(r => {

        this.truckLoadDetail = r;

        if(this.truckLoadDetail.statusHistory && this.truckLoadDetail.statusHistory.length > 0) {
          this.lastStatus = this.truckLoadDetail.statusHistory[0];
        }

      });
    }
  }

   async ngOnInit() {  }

  async getDoc(doc) {
    try {
      this.isLoading = true;
      const resp = await this.documentService.getDoc(doc.reference).toPromise();
      this.isLoading = false;
      if(!resp) return;
      FileSaver.saveAs(resp, doc.fileName, { type: 'application/octet-stream'});
    } catch (e)  {
      this.isLoading = false;
    }

  }
  async getReport(report) {
    try {
      this.isLoading = true;
      const resp = await this.loadService.getReport(report.id, this.truckLoadDetail.domesticDistributionOrderPack.domesticDistributionVoyage.id).toPromise();
      this.isLoading = false;
      if(!resp) return;
      FileSaver.saveAs(resp, `${report.name}.pdf`, { type: 'application/octet-stream'});
    } catch(e) {
      this.isLoading = false;
    }

  }


  isSuccessStatus(stepIndex) {
    const lastStatusStepIndex = this.statusHistoryCodes.findIndex(s => s == this.lastStatus?.status.code);
    return lastStatusStepIndex >= stepIndex;
  }

  statusDate(statusCode) {
      const result = this.truckLoadDetail.statusHistory.reduce((a, b) =>
          a.status.code === statusCode && a.createDate > b.createDate ? a : b);
      return result.createDate;
  }


}
